import React from 'react';
import {
  Badge,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  Col,
  Row,
  Container,
  UncontrolledTooltip,
} from 'reactstrap';
import FilterVariantIcon from 'mdi-react/FilterVariantIcon';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import NewspaperIcon from 'mdi-react/NewspaperIcon';
import ListIcon from 'mdi-react/ViewListIcon';
import GridIcon from 'mdi-react/ViewGridIcon';
import YoutubeIcon from 'mdi-react/YoutubeIcon';
import CommentIcon from 'mdi-react/CommentIcon';
import DownloadIcon from 'mdi-react/CloudDownloadIcon';
import FileIcon from 'mdi-react/FileIcon';
import DeleteIcon from 'mdi-react/DeleteIcon';
import PlayIcon from 'mdi-react/PlayCircleIcon';
import VideoIcon from 'mdi-react/VideoIcon';
import LikeIcon from 'mdi-react/ThumbUpIcon';
import ViewIcon from 'mdi-react/EyeIcon';
import EditIcon from 'mdi-react/EditIcon';
import CalendarIcon from 'mdi-react/CalendarIcon';
import PinIcon from 'mdi-react/PinIcon';
import LightbulbIcon from 'mdi-react/BullhornOutlineIcon';
import StarIcon from 'mdi-react/StarCircleIcon';
import { Link } from 'react-router-dom';
import CloudDownloadIcon from 'mdi-react/CloudDownloadIcon';
import moment from 'moment';
import { toast } from 'react-toastify';
import skeletonTableLoader from '../../../shared/components/custom/SkeletonLoaders';
import Pagination from '../../../shared/components/pagination/Pagination';
import EmptyStateInfo from '../../../shared/components/custom/EmptyStateInfo';
import t, { partial } from '../../../util/translation/translation';
import { getBaseDate } from '../../../util/date-and-time';
import Api from '../../../util/api';
import FormCard from '../../../shared/components/custom/FormCard';
import SquareIconButton from '../../../shared/components/custom/SquareIconButton';

const UNLIMITED_DATE = '9999-12-31T00:00:00.000Z';
const NewsGrid = ({
  news,
  loading,
  onChangePage,
  handleSearch,
  handleInput,
  handleModal,
  order,
  setLoadingNews,
  getNews,
  presentationType,
  handlePresentationTypeChange,
  handleListTypeChange,
}) => {
  const s = partial('shared');
  const p = partial('NewsFormPage');
  const f = partial('NewsForm');

  const getStatusBadge = ({
    access: { visible },
    publicationDate,
    expirationDate,
  }) => {
    if (!visible) {
      return { color: 'secondary', text: p('draft') };
    }
    if (moment().isBefore(moment(publicationDate))) {
      return { color: 'warning', text: t('ScheduledMessagesPage.Scheduled') };
    }
    if (
      moment().isAfter(moment(publicationDate)) &&
      moment().isBefore(moment(expirationDate))
    ) {
      return { color: 'success', text: p('published') };
    }
    if (moment().isAfter(moment(expirationDate))) {
      return { color: 'secondary', text: s('Expired') };
    }
    return { color: 'danger', text: s('somethingWentWrong') };
  };

  const SelectIcon = ({ type }) => {
    switch (type) {
      case 'news':
        return (
          <NewspaperIcon
            size={16}
            style={{ marginTop: -2, marginRight: 4 }}
            color="#818181"
          />
        );
      case 'youtube':
        return (
          <YoutubeIcon
            size={16}
            style={{ marginTop: -2, marginRight: 4 }}
            color="#818181"
          />
        );

      case 'video':
        return (
          <VideoIcon
            size={16}
            style={{ marginTop: -2, marginRight: 4 }}
            color="#818181"
          />
        );
      case 'page':
        return (
          <FileIcon
            size={16}
            style={{ marginTop: -2, marginRight: 4 }}
            color="#818181"
          />
        );
      case 'short':
        return (
          <PlayIcon
            size={16}
            style={{ marginTop: -2, marginRight: 4 }}
            color="#818181"
          />
        );
      default:
        return null;
    }
  };

  const renderNews = () => {
    if (loading) {
      return skeletonTableLoader(4, 8, 70);
    }

    return news.map((n) => {
      const status = getStatusBadge(n);

      return (
        <Col md={12} lg={6} xl={4} key={`news-${n.id}`}>
          <div
            className="bg-white my-1 p-2 rounded border-1"
            style={{
              paddingBottom: 5,
              marginBottom: 10,
              background: '#fff',
              borderRadius: 6,
              boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
            }}
          >
            <div className="flex flex-row justify-content-start">
              <Link to={`/news/edit/${n.id}`}>
                <div
                  className="flex flex-column justify-content-between"
                  style={{ width: n.presentationType === 'short' ? 55 : 160 }}
                >
                  {n.headingImage && (
                    <img
                      className="rounded overflow-hidden"
                      src={n.headingImage}
                    />
                  )}
                  {!n.headingImage && (
                    <div
                      className="rounded"
                      style={{ height: 90, width: 160, background: '#e6e6e6' }}
                    ></div>
                  )}
                </div>
              </Link>
              <div className="flex-1">
                <div className="flex justify-content-between flex-row ml-2">
                  <Badge color={status.color}>{status.text}</Badge>
                  <span
                    style={{ fontSize: 12, marginTop: 2, color: '#818181' }}
                  >
                    {n.presses !== undefined ? (
                      <>
                        <ViewIcon
                          size={16}
                          color="#818181"
                          style={{ marginTop: -2, marginRight: 2 }}
                        />
                        {n.presses}
                      </>
                    ) : (
                      skeletonTableLoader(1, 1, 10)
                    )}
                  </span>
                  <div>
                    <Link
                      to={`/news/edit/${n.id}`}
                      style={{
                        marginLeft: 5,
                        padding: 4,
                        borderRadius: 8,
                        background: '#e6e6e6',
                        borderColor: '#eb4747',
                        borderWidth: 1,
                      }}
                    >
                      <EditIcon
                        size={16}
                        style={{ marginTop: -2 }}
                        color="#818181"
                      />
                    </Link>
                    <button
                      style={{
                        marginLeft: 5,
                        padding: 4,
                        borderRadius: 8,
                        background: '#fad1d1',
                        borderColor: '#eb4747',
                        borderWidth: 0,
                      }}
                      onClick={() => handleModal(true, n.id, 'news')}
                    >
                      <DeleteIcon
                        size={16}
                        style={{ marginTop: -2 }}
                        color="#eb4747"
                      />
                    </button>
                  </div>
                </div>

                <div className="mx-2 mt-1 flex justify-content-between flex-column">
                  {n.isFeatured && (
                    <span style={{ fontSize: 12, color: '#ed9e45' }}>
                      <LightbulbIcon
                        size={16}
                        style={{ marginTop: -4, marginRight: 2 }}
                        color="#ed9e45"
                      />{' '}
                      {s('isFeatured')}
                    </span>
                  )}
                  {(n.access.tiers || n.access.levels || n.access.groups) && (
                    <span style={{ fontSize: 12, color: '#0469dc' }}>
                      <StarIcon
                        size={16}
                        style={{ marginTop: -2, marginRight: 4 }}
                        color="#0469dc"
                      />{' '}
                      {s('isExclusive')}
                    </span>
                  )}
                  <span style={{ fontSize: 12, color: '#818181' }}>
                    <CalendarIcon
                      size={16}
                      style={{ marginTop: -2, marginRight: 4 }}
                      color="#818181"
                    />
                    {getBaseDate(n.publicationDate)}
                    {n.expirationDate !== UNLIMITED_DATE
                      ? ' - ' + getBaseDate(n.expirationDate)
                      : ''}
                  </span>
                  {n.likesEnabled && (
                    <span style={{ fontSize: 12, color: '#818181' }}>
                      <LikeIcon
                        size={12}
                        style={{ marginTop: -2, marginRight: 4 }}
                        color="#818181"
                      />{' '}
                      {n.likes || 0}
                    </span>
                  )}
                  {n.commentsEnabled && (
                    <CommentIcon
                      size={16}
                      style={{ marginTop: -2, marginRight: 4 }}
                      color="#818181"
                    />
                  )}
                  {n.type?.toUpperCase() !== 'CUSTOM' && (
                    <span style={{ fontSize: 12, color: '#818181' }}>
                      <DownloadIcon
                        size={12}
                        style={{ marginTop: -2, marginRight: 4 }}
                        color="#818181"
                      />{' '}
                      {s('isFetched')}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-1">
              {<SelectIcon type={n.presentationType} />}
              {n.isPinned && (
                <PinIcon
                  size={12}
                  style={{ marginTop: -2, marginRight: 4 }}
                  color="#818181"
                />
              )}
              <Link className="block" to={`/news/edit/${n.id}`}>
                {n.title}
              </Link>
            </div>
            {n.categories.length > 0 && (
              <small className="bold block" style={{ color: 'black' }}>
                {n.categories.length ? n.categories.join(',') : ''}
              </small>
            )}
          </div>
        </Col>
      );
    });
  };
  const presentationTypeOptions = [
    { label: s('all'), value: 'all' },
    { label: f('presentationType-news'), value: 'news' },
    { label: f('presentationType-video'), value: 'video' },
    { label: f('presentationType-youtube'), value: 'youtube' },
    { label: f('presentationType-page'), value: 'page' },
    { label: f('presentationType-short'), value: 'short' },
  ];
  const refreshNews = async () => {
    setLoadingNews(true);
    try {
      await Api.news.refreshNews();
      setTimeout(() => getNews(), 3000);
    } catch (err) {
      setLoadingNews(false);
      toast.error(err || p('fetchingNewsFailed'));
    }
  };
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
  return (
    <>
      <div className="form-card__switch mb-3">
        <button
          type="button"
          className="form-card__switch-btn"
          onClick={() => handleListTypeChange('list')}
        >
          <ListIcon size={16} style={{ marginTop: -2, marginRight: 4 }} />
          {capitalize(s('list'))}
        </button>
        <button type="button" className="form-card__switch-btn active">
          <GridIcon size={16} style={{ marginTop: -2, marginRight: 4 }} />
          {capitalize(s('grid'))}
        </button>
      </div>
      <FormCard
        title={s('news')}
        actions={
          <>
            <div
              className="d-none d-md-flex align-items-center"
              style={{ gap: 10 }}
            >
              <div className="icon-actions">
                <UncontrolledDropdown>
                  <DropdownToggle
                    tag="button"
                    type="button"
                    id="news-filter-toggle"
                    className="square-icon-btn"
                    caret={false}
                  >
                    <FilterVariantIcon />
                  </DropdownToggle>
                  <UncontrolledTooltip
                    placement="bottom"
                    target="news-filter-toggle"
                  >
                    {presentationType === 'all'
                      ? s('filter')
                      : f(`presentationType-${presentationType}`)}
                  </UncontrolledTooltip>
                  <DropdownMenu className="dropdown-menu--modern">
                    {presentationTypeOptions.map((option) => (
                      <DropdownItem
                        key={option.value}
                        active={presentationType === option.value}
                        onClick={() => handlePresentationTypeChange(option)}
                      >
                        {option.label}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </UncontrolledDropdown>
                <SquareIconButton
                  icon={<CloudDownloadIcon />}
                  onClick={refreshNews}
                  title={p('fetchNews')}
                  id="news-fetch-btn"
                />
              </div>
              <div className="form noWrap">
                <div className="form__form-group products-list__search">
                  <input
                    placeholder={s('search')}
                    value={news.searchText}
                    onKeyPress={(event) => handleSearch(event.key)}
                    onChange={(event) => handleInput(event.target.value)}
                    name="search"
                    className="rounded"
                  />
                  <MagnifyIcon />
                </div>
              </div>
              <Link to="/news/create">
                <Button size="sm" color="primary" className="mb-0">
                  {s('create')} {s('news')}
                </Button>
              </Link>
            </div>
            <div
              className="d-flex d-md-none align-items-center"
              style={{ gap: 8 }}
            >
              <div className="form noWrap">
                <div className="form__form-group products-list__search">
                  <input
                    placeholder={s('search')}
                    value={news.searchText}
                    onKeyPress={(event) => handleSearch(event.key)}
                    onChange={(event) => handleInput(event.target.value)}
                    name="search"
                    className="rounded"
                  />
                  <MagnifyIcon />
                </div>
              </div>
              <UncontrolledDropdown>
                <DropdownToggle
                  tag="button"
                  type="button"
                  className="square-icon-btn"
                  caret={false}
                >
                  <DotsHorizontalIcon />
                </DropdownToggle>
                <DropdownMenu right className="dropdown-menu--modern">
                  {presentationTypeOptions.map((presentationType) => (
                    <DropdownItem
                      key={`mobile-${presentationType.value}`}
                      onClick={() =>
                        handlePresentationTypeChange(presentationType)
                      }
                    >
                      {presentationType.label}
                    </DropdownItem>
                  ))}
                  <DropdownItem divider />
                  <DropdownItem onClick={refreshNews}>
                    {p('fetchNews')}
                  </DropdownItem>
                  <DropdownItem tag={Link} to="/news/create">
                    {s('create')} {s('news')}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </>
        }
        bodyClassName="form-card__body--flush"
      >
        {!!news && news?.length === 0 && !loading ? (
          <div className="my-3">
            <EmptyStateInfo
              icon="newspaper"
              url="/news/create"
              linkName={p('createNews')}
              title={p('createTitle')}
              text={p('createText')}
            />
          </div>
        ) : (
          <Container fluid>
            <Row>{renderNews()}</Row>
          </Container>
        )}
      </FormCard>
      {(loading || news?.length > 0) && (
        <Pagination
          items={order.total}
          onChangePage={onChangePage}
          initialPage={0}
        />
      )}
    </>
  );
};

export default NewsGrid;
